import { useEffect, useRef, useState, useLayoutEffect } from "react";
import useMedia from "use-media";
import { Button } from '../../atoms/button';

// メッセージ表示ポップアップ
// 一番上に置かないと上手く表示されないので注意
const MessagePopup = (props) => {
    const {
        show,
        message,
        handleOk,
    } = props;

    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);


    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);


    if (!show) {
        return null;
    }

    return (
        <div style={isMobilePhone ? style.blackBackSp : style.blackBack}>
            <div style={isMobilePhone ? style.popUpBackSp : style.popUpBack}>
                <div style={isMobilePhone ? style.popUpContentsDivSP : style.popUpContentsDiv}>
                    <div style={isMobilePhone ? style.popUpSpaceSP : null}>
                        <div style={isMobilePhone ? style.messageStyleSp : style.messageStyle}>
                            {message}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 30 }}>
                            <Button
                                onClick={handleOk}
                                buttonText={"OK"}
                                className="logoutBtn"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


const style = {
    messageStyleSp: {
        textAlign: "center",
        fontSize: '14px',
        whiteSpace: "pre-line"
    },
    messageStyle: {
        textAlign: "center",
        fontSize: 'medium',
        padding: "0px 30px",
        whiteSpace: "pre-line"
    },
    blackBack: {
        background: "rgba(0,0,0,0.5)",
        height: "100%",
        width: "100%",
        position: "fixed",
        zIndex: 1000
    },
    blackBackSp: {
        background: "rgba(0,0,0,0.5)",
        height: "100%",
        width: "100%",
        position: "fixed",
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    popUpBack: {
        position: 'fixed',
        height: "200px",
        width: '400px',
        background: "white",
        top: '0',
        left: '0',
        bottom: '0',
        right: '0',
        margin: 'auto'
    },
    popUpBackSp: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30%",
        width: '100%',
        background: "white",
        top: "70%",
        position: "fixed"
    },
    popUpContentsDiv: {
        display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'
    },
    popUpContentsDivSP: {
        margin: "25% 0px"
    },
    popUpSpaceSP: {
        // marginTop: "15%"
    },
}
export default MessagePopup;